import { render, staticRenderFns } from "./DirectDeliveryAdviceAdd.vue?vue&type=template&id=2246ec68&scoped=true"
import script from "./DirectDeliveryAdviceAdd.vue?vue&type=script&lang=js"
export * from "./DirectDeliveryAdviceAdd.vue?vue&type=script&lang=js"
import style0 from "./DirectDeliveryAdviceAdd.vue?vue&type=style&index=0&id=2246ec68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246ec68",
  null
  
)

export default component.exports